import React, { Component } from 'react';
import styles from './ListDisplay.module.css';
import moment from 'moment';
import { capitalize } from 'store/utility';
import QRCode from 'qrcode.react';
import { Table, Tag, List } from 'antd';

class ListDisplay extends Component {
  // TODO: refactor parse | parseUser | parseDevice
  parse = list => {
    const newList = { ...list };
    const dataSource = [];
    const listKeys = Object.keys(newList);
    for (const key of listKeys) {
      if (key === 'items' || key === 'user' || key === 'id' || key === 'created_at' || key === 'user_id') continue;
      const dataObject = {};
      if (key === 'updated_at') {
        dataObject['label'] = 'Updated at';
        dataObject['value'] = moment.unix(newList[key]).format('DD MMM YYYY');
      } else if (key === 'uuid') {
        dataObject['label'] = 'List ID';
        dataObject['value'] = newList[key];
      } else if (key === 'qr_code') {
        dataObject['label'] = 'QR code';
        dataObject['value'] = newList['uuid'];
      } else if (key === 'company_name') {
        dataObject['label'] = 'Company name';
        dataObject['value'] = newList[key];
      } else if (key === 'delivery_date') {
        dataObject['label'] = 'Delivery date';
        dataObject['value'] = newList[key];
      } else if (key === 'site_contact') {
        dataObject['label'] = 'Site contact';
        dataObject['value'] = newList[key];
      } else if (key === 'order_type') {
        dataObject['label'] = 'Order type';
        dataObject['value'] = newList[key];
      } else if (key === 'remarks') {
        dataObject['label'] = 'Jobsite/Remark';
        dataObject['value'] = newList[key];
      } else if (key === 'total') {
        dataObject['label'] = 'Total Price';
        dataObject['value'] = 'S$' + newList[key];
      } else if (key === 'grand_total') {
        dataObject['label'] = 'Total Price (GST)';
        dataObject['value'] = 'S$' + newList[key];
      } else {
        dataObject['label'] = capitalize(key);
        dataObject['value'] = newList[key];
      }
      if (key !== 'notes') {
        dataSource.push(dataObject);
      }
    }
    return dataSource;
  };

  parseUser = list => {
    const newList = { ...list };
    const { user } = newList;
    if (!user) return [];
    const dataSource = [];
    const userKeys = Object.keys(user);
    for (const key of userKeys) {
      if (key === 'platform' || key === 'uuid' || key === 'id') continue;
      const dataObject = {};
      if (key === 'is_verified') {
        dataObject['label'] = 'Verified';
        if (user.phone_no_id !== 0) {
          dataObject['value'] = '' + user[key];
        } else {
          dataObject['value'] = '';
        }
      } else if (key === 'phone_no') {
        dataObject['label'] = 'Phone no.';
        dataObject['value'] = user[key];
      } else if (key === 'phone_no_id') {
        dataObject['label'] = 'ID';
        dataObject['value'] = user[key] || '';
      } else {
        dataObject['label'] = capitalize(key);
        dataObject['value'] = user[key];
      }
      dataSource.push(dataObject);
    }
    return dataSource;
  };

  parseDevice = list => {
    const newList = { ...list };
    const { user } = newList;
    if (!user) return [];
    const dataSource = [];
    const userKeys = Object.keys(user);
    for (const key of userKeys) {
      if (
        key === 'name' ||
        key === 'phone_no' ||
        key === 'id' ||
        key === 'company' ||
        key === 'is_verified' ||
        key === 'type'
      )
        continue;
      const dataObject = {};
      if (key === 'uuid') {
        dataObject['label'] = 'UUID';
        dataObject['value'] = '' + user[key];
      } else if (key === 'phone_no_id') {
        dataObject['label'] = 'ID';
        dataObject['value'] = user[key];
      } else {
        dataObject['label'] = capitalize(key);
        dataObject['value'] = user[key];
      }
      dataSource.push(dataObject);
    }
    return dataSource;
  };

  renderStatusTag = string => {
    if (string === 'completed') return <Tag color="green">{string}</Tag>;
    if (string === 'ongoing') return <Tag color="blue">{string}</Tag>;
  };

  renderVerifiedTag = string => {
    if (string === 'true') return <Tag color="green">{string}</Tag>;
    if (string === 'false') return <Tag color="red">{string}</Tag>;
  };

  renderRemark = string => {
    return <span style={{ whiteSpace: 'pre-line' }}>{string}</span>;
  };

  renderQRCode = string => {
    return <QRCode size={100} value={string} bgColor={'#ffffff'} fgColor={'#000000'} level={'L'} />;
  };

  columns = (width = 100) => [
    {
      title: 'Label',
      dataIndex: 'label',
      key: 'label',
      width: width,
    },
    {
      title: 'Information',
      dataIndex: 'value',
      key: 'value',
      render: (value, object) => {
        if (object.label === 'Status') return this.renderStatusTag(value);
        if (object.label === 'Verified') return this.renderVerifiedTag(value);
        if (object.label === 'UUID')
          return <span style={{ fontSize: '10px', maxWidth: '165px', overflowWrap: 'break-word' }}>{value}</span>;
        if (object.label === 'List ID')
          return (
            <span>
              <strong>{value}</strong>
            </span>
          );
        if (object.label === 'QR code') return this.renderQRCode(value);
        if (object.label === 'Jobsite/Remark') return this.renderRemark(value);
        return value;
      },
    },
  ];

  renderRooms = array => (
    <List className={styles.List} size="small" dataSource={array} renderItem={item => <List.Item>{item}</List.Item>} />
  );

  columsList = () => [
    {
      title: '#',
      width: 50,
      key: 'id',
      render: (value, row, index) => +(index + 1),
    },
    {
      title: 'Image',
      dataIndex: 'image_url',
      key: 'image_url',
      render: row => <img width="50" height="50" src={row} alt="" />,
      width: 60,
    },
    {
      title: 'Product',
      dataIndex: 'product_title',
      key: 'product_title',
      width: 150,
    },
    {
      title: 'Price',
      dataIndex: 'current_price_string',
      key: 'current_price_string',
    },
    {
      title: 'Unit',
      dataIndex: 'price_unit',
      key: 'price_unit',
    },
    {
      title: 'Qty',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: 'Total',
      dataIndex: 'total_price_string',
      key: 'total_price_string',
    },
    {
      title: 'Dimension',
      dataIndex: 'dimension',
      key: 'dimension',
    },
    {
      title: 'Rooms',
      dataIndex: 'rooms',
      key: 'rooms',
      render: row => this.renderRooms(row),
      width: 100,
    },
  ];

  render() {
    const { list, isLoading } = this.props;
    const listData = this.parse(list);
    const userData = this.parseUser(list);
    const deviceData = this.parseDevice(list);
    const { items: itemsData } = list;
    // TODO: refactor multiple tables into array

    return (
      <div className={styles.Main}>
        <div className={styles.Aside}>
          <span>Meta Information:</span>
          <Table
            loading={isLoading}
            size="small"
            dataSource={listData}
            columns={this.columns()}
            rowKey={row => row.label}
            pagination={false}
            bordered
          />
          <br />
          <span>User Information:</span>
          <Table
            loading={isLoading}
            size="small"
            dataSource={userData}
            columns={this.columns()}
            rowKey={row => row.label}
            pagination={false}
            bordered
          />
          <br />
          <span>Device Information:</span>
          <Table
            loading={isLoading}
            size="small"
            dataSource={deviceData}
            columns={this.columns()}
            rowKey={row => row.label}
            pagination={false}
            bordered
          />
        </div>
        <div className={styles.Content}>
          <Table
            loading={isLoading}
            dataSource={itemsData}
            columns={this.columsList()}
            rowKey={row => row.id}
            pagination={false}
            bordered
            title={() => (
              <span>
                <strong>List Items</strong>
              </span>
            )}
          />
        </div>
      </div>
    );
  }
}

export default ListDisplay;



// WEBPACK FOOTER //
// ./src/components/List/ListDisplay.js